import { ITreeNode } from "@/services/objective-manager";
import { Vue, Component, Watch } from "vue-property-decorator";
import { sortBy } from "lodash";
import { ReportsModule } from "@/modules/reports-objective";
import { fmtMsg, ActionItem } from "commonui";
import { ReportsLocale } from "@/locales/localeid";
import Spinning from "@/components/spinning/spinning.vue";
import LabelText from "@/components/label-text/label-text.vue";
import UnitSelect from "@/components/unit-select/unit-select.vue";
import { disabledDueToAccessLevel, getRouteAccessLevel, pureRichText } from "@/util/func";
import { AccessLevel, SpecialDesignation } from "@/util/enum";

@Component({
	components: {
		Spinning,
		LabelText,
		UnitSelect,
		ActionItem
	}
})
export default class VPCOverviewHeaderActions extends Vue {
	vpcColumns = 4;
	ReportsModule = ReportsModule;
	objectivesArray: ITreeNode[] = [];
	accessLevel = AccessLevel;

	get vcsLevelUnits() {
		return sortBy(ReportsModule.vcsUnits, "unit");
	}

	get exportText() {
		return fmtMsg(ReportsLocale.ReportsExportText);
	}

	get currentRouteAccessLevel() {
		return getRouteAccessLevel(this.$route);
	}

	get disabledDueToAccessLevel() {
		return disabledDueToAccessLevel(this.currentRouteAccessLevel);
	}

	setSelectedUnit(value) {
		ReportsModule.setSelectedUnit(value);
		ReportsModule.setCurrentVersionGroup();
		this.getRelatedData();
	}

	exportPDF() {
		ReportsModule.getUnitOverviewPDF();
	}

	getRelatedData() {
		this.objectivesArray = [];
		ReportsModule.setLoading(true);
		const actions: Promise<any>[] = [];
		actions.push(ReportsModule.getVpcs());
		actions.push(ReportsModule.getLetterphonogramcards());
		actions.push(ReportsModule.getObjectivesTree());
		Promise.all(actions).then(([vpcs, phonograms, data]) => {
			this.formatVpcs(vpcs);
			ReportsModule.setPhonogramCards(phonograms);
			ReportsModule.setObjectivesTree(data.children);
			this.splitTreeNodesToArray(data.children);
			ReportsModule.setFirstObjectivesTree(this.objectivesArray);
			ReportsModule.setLoading(false);
		});
	}

	formatVpcs(vpcs) {
		const vpcsArray: any[] = [];
		const reviewVpcsArray: any[] = [];
		const vocabulary = vpcs.filter((vpc) => vpc.specialDesignationId === SpecialDesignation.VPC);
		let reviewVocabulary = vpcs.filter((vpc) => vpc.specialDesignationId === SpecialDesignation.ReviewVPC);
		reviewVocabulary = sortBy(reviewVocabulary, [(x) => x.title.toLowerCase()], "title");
		const rowsVpcs: number = Math.ceil(vocabulary.length / this.vpcColumns);
		for (var i = 0; i < this.vpcColumns; i++) {
			const aa = vocabulary.slice(rowsVpcs * i, rowsVpcs * i + rowsVpcs);
			vpcsArray.push(aa);
		}
		const rowsReviewVpcs: number = Math.ceil(reviewVocabulary.length / this.vpcColumns);
		for (var i = 0; i < this.vpcColumns; i++) {
			const aa = reviewVocabulary.slice(rowsReviewVpcs * i, rowsReviewVpcs * i + rowsReviewVpcs);
			reviewVpcsArray.push(aa);
		}
		ReportsModule.setVpcsTwoDimension(vpcsArray);
		ReportsModule.setReviewVpcs(reviewVpcsArray);
	}

	splitTreeNodesToArray(array) {
		array.forEach((p, index) => {
			Object.assign(p, {
				show: false,
				title: p.text,
				text: pureRichText(p.text)
			});
			if (p.level != 4) {
				this.objectivesArray.push(p);
			}
			if (p.children.length) {
				this.splitTreeNodesToArray(p.children);
			}
			p.children = null;
		});
	}
}
